// ** Auth Endpoints
export default {
  loginEndpoint: `${process.env.REACT_APP_ACCOUNT_API_URL}/User/Login`,
  registerEndpoint: `${process.env.REACT_APP_ACCOUNT_API_URL}/Account/Register`,
  refreshEndpoint: `${process.env.REACT_APP_ACCOUNT_API_URL}/User/RefreshAccessToken`,
  
  identifierTokenCookieName: `wetu_id_token_${process.env.REACT_APP_ENV}`
}
